var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.40039 16.3999H11.4004V14.3999H9.40039V16.3999ZM10.4004 0.399902C4.88039 0.399902 0.400391 4.8799 0.400391 10.3999C0.400391 15.9199 4.88039 20.3999 10.4004 20.3999C15.9204 20.3999 20.4004 15.9199 20.4004 10.3999C20.4004 4.8799 15.9204 0.399902 10.4004 0.399902ZM10.4004 18.3999C5.99039 18.3999 2.40039 14.8099 2.40039 10.3999C2.40039 5.9899 5.99039 2.3999 10.4004 2.3999C14.8104 2.3999 18.4004 5.9899 18.4004 10.3999C18.4004 14.8099 14.8104 18.3999 10.4004 18.3999ZM10.4004 4.3999C8.19039 4.3999 6.40039 6.1899 6.40039 8.3999H8.40039C8.40039 7.2999 9.30039 6.3999 10.4004 6.3999C11.5004 6.3999 12.4004 7.2999 12.4004 8.3999C12.4004 10.3999 9.40039 10.1499 9.40039 13.3999H11.4004C11.4004 11.1499 14.4004 10.8999 14.4004 8.3999C14.4004 6.1899 12.6104 4.3999 10.4004 4.3999Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelp);
export default __webpack_public_path__ + "static/media/help.572d41044f4aacaa38674681abaef927.svg";
export { ForwardRef as ReactComponent };